module.exports = __webpack_public_path__ + "img/emitEnhanceface02.f8aae6c4.png";